import React, { useState, useContext } from "react";
import BootstrapAlert from "react-bootstrap/Alert";
import { Link } from "react-router-dom";
import { VerifyUserQR } from "../../Services/User/User/user.js";
import { ToasterContext } from "../../App";

const Authenticator = (props) => {
  const { userInfo } = props;
  const [code, setCode] = useState("");
  // eslint-disable-next-line
  const [tostify, setTostify] = useContext(ToasterContext);

  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (code === "") {
      setError("Code is Empty");
    } else {
      setError("");
      const data = await VerifyUserQR({ code: code });
      if (data.data === 200) {
        setTostify({
          ...tostify,
          visible: true,
          key: Math.random().toString(36).substring(7),
          type: "success",
          message: "Successfully Verified",
        });
        if (userInfo) {
          localStorage.setItem("token", sessionStorage.getItem("token"));
          // setJwtToken("token", response?.token);
          localStorage.setItem("user", JSON.stringify(userInfo));
          localStorage.setItem("rights", JSON.stringify(userInfo?.rights[0]));
          localStorage.setItem(
            "role",
            userInfo?.admin
              ? "admin"
              : userInfo?.superAdmin
              ? "superAdmin"
              : "user"
          );
          localStorage.setItem(
            "permissions",
            userInfo?.permissions ? userInfo?.permissions : "user"
          );
        }
        window.location = "/dashboard";
      } else {
        setTostify({
          ...tostify,
          visible: true,
          key: Math.random().toString(36).substring(7),
          type: "error",
          message: "Invalid Authentication code ",
        });
      }
    }
  };

  return (
    <>
      <div className="user-ath">
        <div className="user-ath-page">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-8 text-center">
                <div className="user-ath-logo logo-width">
                  <span>
                    <img
                      src="images/logo-sm.png"
                      srcSet="images/logo.png"
                      alt="icon"
                    />
                  </span>
                </div>
                <div className="user-ath-box">
                  <h4>Authenticator</h4>
                  <BootstrapAlert
                    variant="success"
                    style={{ padding: "6px 20px" }}
                  >
                    <p style={{ color: "#fff" }}>
                      Enter Your Authenticator App Code
                    </p>
                  </BootstrapAlert>
                  <form className="user-ath-form">
                    <div className="input-item">
                      <input
                        name="code"
                        type="text"
                        placeholder="Enter Code"
                        className="input-bordered"
                        value={code}
                        onChange={(e) => {
                          setCode(e.target.value);
                        }}
                      />
                      <span className="error">{error}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <button
                        onClick={handleSubmit}
                        className="btn btn-primary w-100"
                      >
                        Verify & login
                      </button>
                    </div>
                  </form>
                </div>
                <div className="form-note" style={{ paddingTop: "20px" }}>
                  {" "}
                  Go To Home? <Link to={"/"}> Betts</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Authenticator;
